/** Quotation product image formats supported by PDF generation (ReportLab raster). */
export const QUOTATION_PRODUCT_IMAGE_ACCEPT =
  'image/png,image/jpeg,image/jpg,image/webp,image/bmp,image/gif,image/tiff,.tif,.tiff,.bmp';

export const QUOTATION_PRODUCT_IMAGE_LABEL =
  'PNG, JPG, JPEG, WEBP, BMP, GIF, TIFF';

const SUPPORTED_MIME = new Set([
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/bmp',
  'image/x-ms-bmp',
  'image/gif',
  'image/tiff',
  'image/tif',
]);

const SUPPORTED_EXT = new Set([
  'png',
  'jpg',
  'jpeg',
  'webp',
  'bmp',
  'gif',
  'tif',
  'tiff',
]);

const UNSUPPORTED_EXT = new Set(['heic', 'heif', 'avif', 'svg']);

const UNSUPPORTED_MIME = new Set([
  'image/heic',
  'image/heif',
  'image/avif',
  'image/svg+xml',
]);

function fileExtension(file) {
  const name = String(file?.name || '');
  const i = name.lastIndexOf('.');
  if (i < 0) return '';
  return name.slice(i + 1).toLowerCase();
}

/**
 * Validate quotation product image file.
 * @returns {{ ok: true } | { ok: false, reason: string }}
 */
export function validateQuotationProductImage(file) {
  if (!file) return { ok: false, reason: 'No file selected.' };

  const ext = fileExtension(file);
  const mime = String(file.type || '').toLowerCase();

  if (UNSUPPORTED_EXT.has(ext) || UNSUPPORTED_MIME.has(mime)) {
    return {
      ok: false,
      reason: `${ext.toUpperCase() || 'This'} format is not supported. Use ${QUOTATION_PRODUCT_IMAGE_LABEL}. HEIC, AVIF, and SVG are not allowed.`,
    };
  }

  if (SUPPORTED_MIME.has(mime) || SUPPORTED_EXT.has(ext)) {
    return { ok: true };
  }

  // Some browsers leave type empty for TIFF/BMP — allow by extension only above.
  if (mime.startsWith('image/')) {
    return {
      ok: false,
      reason: `Unsupported image type. Use ${QUOTATION_PRODUCT_IMAGE_LABEL}.`,
    };
  }

  return {
    ok: false,
    reason: `Please select an image file (${QUOTATION_PRODUCT_IMAGE_LABEL}).`,
  };
}
